import { RiUserAddLine } from "@remixicon/react";
import { createPortal } from "react-dom";
import React, { useRef, useState } from "react";
import { useRegisterAction } from "../../../contexts/ticket-state";
import {
    ActionContext,
    ActionHandler,
    ActionType,
    HANDLER_INTERFACE,
    HandlerButton,
} from "../../../contexts/ticket-state/action-registry";
import Users from "../../pickers/users/Users";
import Dropdown from "../../theme/dropdown/Dropdown";
import Styles from "./add-participants.module.scss";

function Button({
    button, onSelected, onClick,
}: {
    button: HandlerButton;
    onSelected(ids: string[]): void;
    onClick: () => void;
}) {
    const [shouldShow, setShouldShow] = useState(false);

    const doToggle = (isNextShow: boolean) => {
        setShouldShow(isNextShow);
        if (isNextShow) {
            onClick();
        }
    };

    return (
        <Dropdown show={shouldShow} onToggle={doToggle} className="action">
            <Dropdown.Toggle
                size="small"
                onClick={() => {
                    setShouldShow(!shouldShow);
                    if (!shouldShow) {
                        onClick();
                    }
                }}
                variant={button.variant}
                prefixIcon={button.icon}
            >
                {button.text}
            </Dropdown.Toggle>
            {createPortal(
                <Dropdown.Menu className={Styles.container}>
                    <span className={Styles.label}>Add Participant</span>
                    <Users
                        isMulti
                        shouldShowMenu
                        shouldShowSelfFirst
                        className={Styles.picker}
                        onSelected={onSelected}
                        value={[]}
                    />
                </Dropdown.Menu>,
                document.body,
            )}
        </Dropdown>
    );
}

export default function AddParticipant() {
    const actionHandler = useRef<ActionHandler>();

    useRegisterAction({
        createBulkActionButton(items, context) {
            return context === ActionContext.BULK_ACTION ? {
                text: "Add Participants",
                icon: <RiUserAddLine />,
                variant: "ghost-gray",
                render: props => (
                    <Button
                        onSelected={ids => {
                            actionHandler.current?.items.forEach(ticket => ticket.addParticipants(ids));
                            actionHandler.current?.done();
                        }}
                        {...props}
                    />
                ),
            } : undefined;
        },
        handleBulkAction(handler) {
            if (handler.context === ActionContext.TICKET_ACTION) {
                handler.items.forEach(item => item.closeIfOpen());
            }

            actionHandler.current = handler;
        },
    }, ActionType.MOVE);

    return null;
}

HANDLER_INTERFACE.register(AddParticipant);
